<template>
  <div>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          label-position="left"
          class="flex-row-between"
          label-width="70px"
        >
          <el-form-item label="订单号">
            <el-input
              size="mini"
              v-model="number"
              placeholder="订单号"
            ></el-input>
          </el-form-item>
          <el-form-item label="回款日期">
            <el-date-picker
              v-model="date"
              size="mini"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <el-button size="mini" type="primary" @click="startFilter()"
          >搜索</el-button
        >
        <el-button size="mini" @click="clearFilter">清空</el-button>
      </div>
    </div>
    <div class="panel mt-20">
      <el-table
        v-if="!isMobile()"
        :data="collections"
        style="width: 100%"
        key="collections"
      >
        <el-table-column label="订单">
          <template slot-scope="scope">
            <order-link :order="scope.row.order"></order-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="回款金额"
          width="100"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="date"
          label="回款时间"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.date) }}</span></template
          >
        </el-table-column>
        <el-table-column prop="user" label="操作人" width="100" align="center"
          ><template slot-scope="scope">
            <span>{{ scope.row.user.name }}</span></template
          >
        </el-table-column>
      </el-table>
      <ul v-else class="list-style">
        <li v-for="item in collections">
          <div><order-link :order="item.order"></order-link></div>
          <div>回款金额：￥{{ item.amount }}</div>
          <div class="flex-row-between font-12">
            <span>操作人：{{ item.user.name }}</span>
            <span>{{ formatTime(item.date) }}</span>
          </div>
        </li>
      </ul>
      <div v-if="collections.length == 0 && isMobile()" class="text-info-12">
        暂未创建回款记录。
      </div>
      <el-pagination
        class="mt-20"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        layout="total, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { customerCollectionList } from '../../service/getData'
import { formatTime } from '@/util/index'
import { isMobile } from '../../util'

export default {
  props: {
    customerID: {
      type: Number,
      default: 0,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formatTime: formatTime,
      collections: [],
      total: 0,
      isMobile,
      number: '',
      date: null,
      pageSize: 20,
      currentPage: 1,
    }
  },
  watch: {
    currentPage() {
      this.requestCustomerCollections()
    },
  },
  created() {
    this.requestCustomerCollections()
  },
  methods: {
    refresh() {
      this.clearFilter()
    },
    async requestCustomerCollections() {
      let data = {
        page: this.currentPage - 1,
        size: this.pageSize,
        number: this.number,
        customer_id: this.customerID,
      }
      if (this.date) {
        data.start_date = this.date[0]
        data.end_date = this.date[1]
      }

      let res = await customerCollectionList(data)

      if (res.code == 0) {
        this.collections = res.data.list
        this.total = res.data.total
      }
    },
    startFilter() {
      this.currentPage = 1
      this.requestCustomerCollections()
    },
    clearFilter() {
      this.number = ''
      this.date = null
      this.currentPage = 1
      this.requestCustomerCollections()
    },
  },
}
</script>

<style scoped>
.el-date-editor .el-range-input {
  width: 100px !important;
}
</style>